<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.general') }}</h5>
    </template>

    <b-row>
      <b-col md="6">
        <o-value-select v-model="item.user_id"
                        :label="$t('sandoz.owner')"
                        :readonly="readonly"
                        text-field="name"
                        value-field="id"
                        url="/api/system/users?filter%5Bactive%5D=1%25&sortBy=name"/>

        <o-value-select v-model="item.type"
                        :label="$t('sandoz.type')"
                        :readonly="readonly || !!item.id"
                        :items="contractTypes"/>

        <o-form-group :label="$t('sandoz.contract_year')">
          <b-form-input v-model="item.contract_year" type="number" :readonly="readonly"/>
        </o-form-group>

        <o-form-group :label="$t('sandoz.contract_no')">
          <b-form-input v-model="item.contract_no" :readonly="true"/>
        </o-form-group>

        <o-form-group v-if="item.contract_no_suffix" :label="$t('sandoz.contract_suffix')">
          <b-form-input v-model="item.contract_no_suffix" :readonly="true"/>
        </o-form-group>
      </b-col>

      <b-col md="6">
        <o-form-group :label="$t('sandoz.customer_external_id')">
          <b-input-group>
            <b-form-input :value="item.customer_external_id || ''" disabled/>
          </b-input-group>
        </o-form-group>

        <o-form-group :label="$t('sandoz.customer')">
          <b-form-input :value="customerLabel" disabled/>
        </o-form-group>

        <o-form-group :label="$t('sandoz.new_customer')">
          <b-form-radio-group v-model="item.new_customer" :options="newCustomerOptions" :disabled="readonly"/>
        </o-form-group>

        <o-form-group v-if="item.previous_contract" :label="$t('sandoz.previous_contract')">
          <b-form-input :value="String(item.previous_contract)" :readonly="true"/>
        </o-form-group>
      </b-col>
    </b-row>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * Header fields: owner, type, year, customer, previous contract.
 * Status badge lives at the page level (in ContractDetail.vue), not duplicated here.
 *
 * Source: kam/ContractDetail.vue (most complete header).
 */
export default {
  name: 'SectionGeneral',
  mixins: [sectionMixin],
  data() {
    return {
      // Populated in Phase 4 follow-up — for now, just use the literal type list pulled from
      // the contract type ENUM in the migrations.
      contractTypes: [
        'APO', 'SD', 'CNS', 'HEIM', 'IMMUNO', 'ONCO',
        'KAM_APO', 'KAM_SD', 'KAM_HOSP', 'KAM_WHS',
        'KAM_DIVERSE', 'KAM_DIVERSE_HOSP', 'KAM_DIVERSE_INSUR',
        'APO_ONE', 'OTC',
        'SD_GADGET', 'CNS_GADGET', 'ONCO_GADGET', 'IMMUNO_GADGET',
        'KAM_SD_GADGET', 'APO_GADGET', 'KAM_APO_GADGET', 'HIGHSPEC_GADGET',
        'SD_SORTALYS', 'CNS_SORTALYS', 'ONCO_SORTALYS', 'IMMUNO_SORTALYS',
        'KAM_SD_SORTALYS', 'HIGHSPEC_SORTALYS',
        'SD_EDU', 'CNS_EDU', 'IMMUNO_EDU', 'ONCO_EDU',
        'KAM_SD_EDU', 'APO_EDU', 'KAM_APO_EDU',
        'PV', 'BIOS_APO', 'BIOS_KAM_APO', 'BIOS_KAM_WHS', 'APO_OTC',
        'APO_KUKO', 'SD_KUKO', 'IMMUNO_KUKO', 'HOSP_KUKO', 'CNS_KUKO'
      ].map(t => ({ value: t, text: t })),
      newCustomerOptions: [
        { value: 'x', text: this.$t('sandoz.yes') },
        { value: null, text: this.$t('sandoz.no') }
      ]
    }
  },
  computed: {
    customerLabel() {
      const parts = [this.item.customer_no_xpris, this.item.customer_no_sap]
        .filter(Boolean)
      return parts.length ? parts.join(' / ') : '-'
    }
  }
}
</script>
